import { useOutletContext } from 'react-router';
import type { Eu } from './api';

/** Sessão (usuário, workspace, permissões e módulos instalados) para as páginas dos módulos. */
export function useSessao(): Eu {
  return useOutletContext<Eu>();
}

export function pode(eu: Eu, permissao: string): boolean {
  return eu.permissoes.includes('*') || eu.permissoes.includes(permissao);
}
